import Icons from "assets/Icons";
import Error from 'components/alerts/Error'
import { Select } from 'components/common/form/modules/input/Select';

import { Text } from 'components/common/form/modules/input/Text';
import { closeModal, openModal } from 'components/modal/modules/dispatcher/methods';
import EventDescription from 'components/platform/card/modules/EventDescription/EventDescription';
import TicketItem from 'components/platform/ticket-list/TicketListItem';
import { CreditCardForm } from 'components/stripe/CreditCardForm';
import { getCookie } from 'lib/utils/cookie';
import { Component } from 'react';
import React, { ReactNode } from 'react';
import { withCookies } from 'react-cookie';
import { Button, CardImg, Col, Input, Row } from 'reactstrap';
import Label from 'reactstrap/lib/Label';
import { fetchGraphQL } from 'services/graphql/GraphQL';
import { Card } from '../../../../components/common/card/Card';
import MoreEventsByCheckoutPage from './MoreEventsByCheckoutPage';

import Switch from 'react-switch';

interface IEventBlock {
	[label: string]: any;
	children?: ReactNode;
}

class CheckOut extends Component<IEventBlock> {
	public state = {
		ticketOrder: {},
		ticketMap: {},
		charging: false,
		firstName: '',
		agreed: false,
		agreedRISD: true,
		lastInitial: '',
		formData: { fullName: '', email: '', emailConfirm: '', phoneNumber: '' },
		user: {
			id: '',
			name: '',
			lastname: '',
			avatar: '',
			email: '',
		},
		timeInfo: {
			startYear: 0,
			startMonth: 0,
			startDay: 0,
			startHour: 0,
			startMinutes: 0,
			startAMPM: 0,
			endYear: 0,
			endMonth: 0,
			endDay: 0,
			endHour: 0,
			endMinutes: 0,
			endAMPM: 0
		},
		switched: true,
		error: false,
		isBought: false,
	};
	constructor(props) {
		super(props);
		this.state = {
			charging: false,
			ticketOrder: {},
			ticketMap: {},
			formData: { fullName: '', email: '', emailConfirm: '', phoneNumber: '' },
			user: {
				id: '',
				name: '',
				lastname: '',
				avatar: '',
				email: ''
			},
			firstName: '',
			lastInitial: '',
			error: false,
			agreed: false,
			agreedRISD: true,
			isBought: false,
			switched: true,
			timeInfo: {
				startYear: 0,
				startMonth: 0,
				startDay: 0,
				startHour: 0,
				startMinutes: 0,
				startAMPM: 0,
				endYear: 0,
				endMonth: 0,
				endDay: 0,
				endHour: 0,
				endMinutes: 0,
				endAMPM: 0
			}
		};

		this.getQty = this.getQty.bind(this);
		this.countTotalTicketPrice = this.countTotalTicketPrice.bind(this);
		this.countSubTotalPriceWithSfandTax = this.countSubTotalPriceWithSfandTax.bind(this);
		this.countTotalPrice = this.countTotalPrice.bind(this);
		this.countTotalTickets = this.countTotalTickets.bind(this);
		this.handleAddTicket = this.handleAddTicket.bind(this);
		this.handleFormInputChange = this.handleFormInputChange.bind(this);
		this.handlePurchase = this.handlePurchase.bind(this);
		this.emailIsValid = this.emailIsValid.bind(this);
		this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
		this.handleLastInitialChange = this.handleLastInitialChange.bind(this);
		this.countTax = this.countTax.bind(this);
		this.fetchNeededData = this.fetchNeededData.bind(this);
		this.handleEmailInputChange = this.handleEmailInputChange.bind(this);
		this.showTermsAndConditions = this.showTermsAndConditions.bind(this);
		this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
		this.changeDonation = this.changeDonation.bind(this);
	}

	public componentDidMount() {
		this.fetchNeededData()
		const ticketMap = {};
		const ticketOrder = {};
		if (this.props.privateTicket && this.props.privateTicket !== []) {
			this.props.privateTicket.forEach((pt, index) => {
				ticketMap[pt.ticketBankId] = index;
				ticketOrder[pt.ticketBankId] = pt;
				ticketOrder[pt.ticketBankId].id = pt.ticketBankId;
			});
		} else {
			this.props.publicTickets.forEach((pt, index) => {
				ticketMap[pt.id] = index;
			});
		}
		this.setState({
			ticketMap, ticketOrder
		})
		if (this.props.id === '5deea2d7f2fad353eed0eaab' ||
			this.props.id === '5deea257f2fad353eed0e822' ||
			this.props.id === '5deea1d2f2fad353eed0e585' ||
			this.props.id === '5deea00af2fad353eed0da34') {
			this.setState({ agreedRISD: false })
		}

		if (
			this.props.id === '5e894f3e7a3aa10ea99d2165'
			|| this.props.id === '5e8aaa017a3aa10ea99eb23e'
			|| this.props.id === '5e89460d7a3aa10ea99d12a9'
			|| this.props.id === '5e88859c7a3aa10ea99c5055'
		) {
			this.setState({
				formData: {
					...this.state.formData,
					phoneNumber: '10-12'
				}
			})
		}

	}

	public changeDonation() {
		this.setState({
			switched: !this.state.switched
		})
	}

	public showTermsAndConditions() {
		const content = <div>
			<p>
				{
					this.props.id === '5d975f25a6404e72b39b6ffe' ?
						'By purchasing this ticket, I understand that this is a RISD sponsored event and that all attendees are expected to adhere to the policies of the institution. NO TICKET, NO ENTRY. You must have a ticket for entry to the event. Tickets are not available at the door only for pre-sale. NO RE-ENTRY. (If you leave the ball, you will not be re-admitted). DOORS CLOSE AT MIDNIGHT (12:00AM). If you’re planning to attend, please be inside the event by that time. Otherwise you will not be allowed in. NO COAT CHECK OR BELONGING STORAGE. While there will be racks to hang your items on at your own risk, event staff (and RISD) will not watch or be responsible for personal items. If you lose something, check with RISD public safety (30 Waterman) after the event to see if it’s been turned in. ARTIST BALL IS A SMOKE FREE AND VAPE FREE EVENT. In accordance with our smoke-free campus policies and Kennedy Plaza’s commitment to being smoke-free, Artist Ball 2019 is a smoke and vape-free event. If you intend to purchase alcohol at the event, you must present a valid passport or state issued ID along with your RISD ID. NO EXCEPTIONS. We expect that you will act accordingly and with respect to the staff who are working the event and we reserve the right to remove participants from or deny entry to the event at any time without warning regardless of the purchase of a ticket. Because of RISD\'s commitment to ensuring student and event safety, Please note the following: NO BACKPACKS AND/OR LARGE TOTES will be allowed into the venue. Any small bags and or costumes/persons may be subject to visible search and/or metal detection by Public Safety, RISD Staff, or other event personnel. Prohibited items include but are not limited to: Drugs/Medication not accompanied by a valid prescription. Alcohol, Drink containers or any containers with liquid, Weapons, (real, pretend, or anything deemed by Public Safety as items that could pose a concern for the safety and well-being of attendees). Participants donning costumes deemed culturally insensitive or offensive may be denied entry or asked to change or modify their costume before being granted entry. Those appearing to be impaired will be evaluated by medical personnel, and if necessary removed from the event or transported to the hospital. Buses will be available to shuttle students to and from the venue. More information about routes will be posted to the CSI Facebook page and emailed to students who purchase tickets.\n\n'
						: null
				}
				THIS TICKET (“Ticket”) IS A REVOCABLE LICENSE (“License”) SUBJECT TO TERMS AND CONDITIONS ESTABLISHED BY THE VENUE OPERATOR or other authorized entity(ies) (individually, or collectively as the context requires, “Licensor”) in connection with the event identified on the front or main portion of this Ticket (the “Event”) to the licensee of the Ticket (“Licensee”) pursuant to certain terms and conditions as may be established by Licensor, including those set forth below. This Ticket grants the bearer thereof only the right to: (a) enter the publicly-accessible areas of the Event venue (the “Venue”) on dates and at times determined by Licensor; (b) attend the Event; and (c) occupy the seat location identified on the front or main portion of this Ticket during the Event, unless this Ticket has been designated as a “General Admission” Ticket. No resale or offer to resell this Ticket is permitted to the extent prohibited by any applicable federal, state or local law or regulation. Any violation of the terms and conditions shall give Licensor the right to revoke the License immediately without having to refund the established price. Licensor reserves the right to refuse admission or eject any person who violates Licensor’s policies. All persons seeking entry into the Venue specifically consent to and are subject to metal detector and physical pat-down inspections prior to entry and the bearer consents to such searches and waives any related claims that may arise therefrom. If the bearer elects not to consent to such searches, the bearer will be denied entry into the Venue. All bags may be thoroughly inspected. Any person or object that could affect the safety of the Venue, its occupants or its property shall be denied entry. By using this Ticket, each of Licensee or bearer of this Ticket, agrees that: (i): he/she shall not transmit or aid in transmitting any information about the Event, including, but not limited to, any account, description, picture, video, audio, reproduction or other information concerning the Event (collectively, “Event Information”); (ii) Licensor is the exclusive owner of all copyrights and other proprietary rights in the Event and Event Information; and (iii) Licensor and its lawful agents, successors and assigns shall have the unrestricted right and license to use Licensee’s image, likeness, name, voice, comments or other proprietary or public rights and that of any minor accompanying Licensee, in any broadcast, telecast, photograph, video, audio sound, audiovisual and/or other recording taken of, or made in connection with, the Event or other transmission or reproduction, in whole or in part, of the Event, for all purposes, worldwide, in perpetuity and in any and all means and media now or hereafter known, without compensation. The rights granted herein to Licensor are assignable. WAIVER AND RELEASE OF LIABILITY: The bearer recognizes that his/her attendance at the Event is voluntary and may result in personal injury, property damage, or death. The bearer assumes all risk and danger incidental to the Event, and agrees that Licensor, Isotope, Inc., each of the foregoing entities’ respective agencies, departments, subdivisions and each of their officials, directors, agents, players, officers, employees and owners shall not be liable for any personal injury, property loss/damage, or death, whether occurring prior to, during, or after the Event, howsoever caused and whether by negligence or otherwise. This Ticket is not subject to any refund and shall bear no cash value. LICENSEE SHALL HAVE THE RIGHT, IN ITS SOLE DISCRETION, WITHIN TWELVE (12) MONTHS OF THE DATE OF THE SCHEDULED EVENT, TO EXCHANGE THIS TICKET FOR A COMPARABLY PRICED AND SITUATED TICKET TO ATTEND A RESCHEDULED PRESENTATION OF THE SAME EVENT OR ANOTHER SIMILAR EVENT, AS DESIGNATED BY LICENSOR IN ITS SOLE AND ABSOLUTE DISCRETION. GENERAL INFORMATION: 1. This Ticket may not be used for advertising, promotions (including contests and sweepstakes) or other trade or commercial purposes without the express written consent of Licensor. 2. Licensor reserves the right to change all Venue policies without prior notice. 3. In no event will Licensor be liable for any direct, indirect, consequential, exemplary, incidental, special or punitive damages or for lost profits, revenues or business opportunities even if Licensor has been advised of the possibility of such damages. 4. The License shall be governed by the law of the state in which the Venue is located, without giving effect to conflict of laws principles thereof. The exclusive venue for any disputes arising out of the License granted by this Ticket shall be the state or federal courts of the state in which the Venue is located. NO EXCHANGES EXCEPT AS PROVIDED HEREIN. NO CASH VALUE. NO REFUNDS. NO RE-ENTRY.
			</p>
			<br />
			<div className="Seperate-Buttons">
				<button
					className='new-button-white-3'
					style={{ border: 'none' }}
					onClick={e => { closeModal() }}
				>
					DONE
                </button>
			</div>
			<p>
				<br />
			</p>
		</div>
		openModal(content, 'Terms and Conditions')
	}

	public fetchNeededData() {
		const { code, userCode } = this.props;

		console.log(this.props.promoterId)
		console.log(getCookie("token"))
		console.log(getCookie("user"))
		console.log(getCookie(code + userCode))
		// First let's update the pageViews for these pages and ensure that there is no redundancies

		// offer ticket
		if (this.props.ticketCode && !getCookie("token") && !getCookie("user") && !getCookie(this.props.ticketCode)) {
			const date = new Date(); date.setDate(date.getDate() + 7);
			this.props.cookies.set(this.props.ticketCode, this.props.ticketCode, { path: "/", expires: date });
			fetchGraphQL(
				`
					mutation { 
						ticket {
							updateClicks(code:"${this.props.ticketCode}") 
						}
					}
				`
			).then((value: any) => {
				// console.log(value);
			});
		}
		// referral
		else if (this.props.promoterId !== undefined && this.props.promoterId !== null && !getCookie("token") && !getCookie("user") && !getCookie(code + userCode)) {
			const date = new Date(); date.setDate(date.getDate() + 7);
			this.props.cookies.set(code + userCode, code + userCode, { path: "/", expires: date });
			fetchGraphQL(`
			mutation {
				url {
					updateReferralViews(code:"${code}", userCode:"${userCode}")
				}
			}
			`).then(res => {
				// console.log('')
				console.log(res)
			})
		}
		// general link
		else if (!getCookie("token") && !getCookie("user") && !getCookie(code)) {
			const date = new Date(); date.setDate(date.getDate() + 7);
			try {
				this.props.cookies.set(code, code, { path: "/", expires: date });
			} catch (e) {
				console.log(e)
			}
			fetchGraphQL(`
			mutation {
				url {
					updateGeneralViews(code:"${code}")
				}
			}
			`).then(res => {
				// console.log('')
			})
		}
		// Load everything else
		if (this.props.promoterId !== null && this.props.promoterId !== undefined) {
			fetchGraphQL(
				`
					{
						user {
							findById(id:"${this.props.promoterId}") {
							id
							name
							lastname
							avatar
							email
							}		
						}
					}
				`
			).then((value: any) => {
				if (value !== null) {
					this.setState({ ...this.state, user: value.user.findById });
				}
			});
		} else {
			this.setState({ ...this.state, user: { ...this.state.user, name: null } });
		}
		fetchGraphQL(
			`
			query {
				time {
					findByEventId(id:"${this.props.id}") {
						startYear
						startMonth
						startDay
						startHour
						startMinutes
						startAMPM
						endYear
						endMonth
						endDay
						endHour
						endMinutes
						endAMPM
					}
				}
			}
			`).then((time => {
				this.setState({ timeInfo: time.time.findByEventId });
			}))
		// Check if the ticket is bought
		if (this.props.ticketCode !== null && this.props.ticketCode !== undefined) {
			fetchGraphQL(

				`
					{
						ticket {
							get(ticketCode:"${this.props.ticketCode}") {
								code
								status
							}		
						}
					}
				`
			).then((value: any) => {
				// const response = value.ticketBank.update;
				if (value !== null &&
					value.ticket !== null &&
					value.ticket.get !== null) {
					if (value.ticket.get.status !== "activated" && value.ticket.get.status !== "available") {
						this.setState({
							isBought: true
						})
					}

				}
			});
		}
	}

	/**
	 * Handle add or delete of ticket
	 * @param id
	 * @param qty
	 */
	public handleAddTicket(e: any, id: string, add: boolean) {

		e.preventDefault();
		const ticketOrder = this.state.ticketOrder;

		let count = 0;
		if (add) {
			count = 1;
		} else {
			count = -1;
		}


		// RISD HARDCODE PART 1 END =====================================================

		if (this.props.id === '5e28bddffb65960ef12149a0') {
			// If you trying to add those two without anf of the prev one
			if (id === '5e41e8f149fc4b22a837b66a' || id === '5e41ea1449fc4b22a837c40c') {
				if (add) {
					if (
						(ticketOrder['5e28c4b6fb65960ef12171b0'] === undefined || ticketOrder['5e28c4b6fb65960ef12171b0'].count === 0) &&
						(ticketOrder['5e28c4d9fb65960ef12174c7'] === undefined || ticketOrder['5e28c4d9fb65960ef12174c7'].count === 0) &&
						(ticketOrder['5e28c502fb65960ef12174dc'] === undefined || ticketOrder['5e28c502fb65960ef12174dc'].count === 0)
					) {
						return;
					}
				}
			}
			if (id === '5e28c4b6fb65960ef12171b0' || id === '5e28c4d9fb65960ef12174c7' || id === '5e28c502fb65960ef12174dc') {
				if (!add) {
					let cnt = 0;
					let cnt2 = 0;
					Object.keys(ticketOrder).map(it => {
						if (ticketOrder[it] !== undefined) {
							if (it !== '5e41e8f149fc4b22a837b66a' && it !== '5e41ea1449fc4b22a837c40c') {
								cnt += ticketOrder[it].count
							} else {
								cnt2 += ticketOrder[it].count
							}
						}
					})
					if (cnt === 1 && cnt2 !== 0) {
						return;
					}
				}

			}
			// if ((id === '5e41e8f149fc4b22a837b66a' || id === '5e41ea1449fc4b22a837c40c') && !add) {
			// 	if ((ticketOrder['5e28c4b6fb65960ef12171b0'] === undefined || ticketOrder['5e28c4b6fb65960ef12171b0'].count === 0) &&
			// 		(ticketOrder['5e28c4d9fb65960ef12174c7'] === undefined || ticketOrder['5e28c4d9fb65960ef12174c7'].count === 0) &&
			// 		(ticketOrder['5e28c502fb65960ef12174dc'] === undefined || ticketOrder['5e28c502fb65960ef12174dc'].count === 0)) {
			// 		return;
			// 	}
			// }
		}

		// Hard code for Pamela END

		// Event Restrictions Do Not Disturb
		if (add && this.props.publicTickets[this.state.ticketMap[id]].quantity === -1) {
			// Get total count and compare that to remaning capactiy.
			// Then proceed
			let totalSoFar = 0;
			Object.keys(ticketOrder).map(key => {
				if (this.props.publicTickets[this.state.ticketMap[key]].quantity === -1) {
					totalSoFar += ticketOrder[key].count
				}
			})
			if (totalSoFar >= this.props.capacityRemaining) {
				return
			}
		}

		// We do not need ticket map here
		// where else is it being used? check
		let item: any = {};
		item = this.props.publicTickets.find(i => {
			return i.id.toString().trim() === id.toString().trim()
		})

		const maxLimitOrder = this.props.configuration.maxTicketsPerOrder || 0;

		if (ticketOrder[id] === undefined) {
			if (
				1 <= item.available &&
				(maxLimitOrder > 0 && this.countTotalTickets() < maxLimitOrder)
			) {
				if (add) {
					ticketOrder[id] = {
						count: 1,
						price: item.price,
					};
					this.setState({ ticketOrder });
				} else {
					ticketOrder[id] = {
						count: 0,
						price: item.price,
					};
				}
			} else {
				// console.log('Limit Reached');
			}
		} else {
			if (add) {
				if (
					this.state.ticketOrder[id].count < item.available &&
					// (maxLimit > 0 && ticketOrder[id].count < maxLimit) &&
					(maxLimitOrder > 0 && this.countTotalTickets() < maxLimitOrder)
				) {
					ticketOrder[id].count += count;

					this.setState({ ticketOrder });
				} else {
					// console.log('Limit Reached');
				}
			} else {
				if (ticketOrder[id].count - 1 >= 0) {
					ticketOrder[id].count -= 1;
					this.setState({ ticketOrder });
				}
			}
		}
		// End of Event Restrictions

		// RISD HARDCODE PART 2 =========================================================
		// Event 1
		if (this.props.id === '5deea2d7f2fad353eed0eaab') {
			const A = '5deff8a7f2fad353eed424da';
			const B = '5df00a4df2fad353eed45a5b';
			const C = '5df00a5cf2fad353eed45ab4';
			const D = '5df00a82f2fad353eed45ac9';
			// const E = '5df00a9df2fad353eed45b26';
			if (id === B || id === C || id === D) {
				this.handleAddTicket(e, A, add);
				return;
			}
		}
		// Event 2
		if (this.props.id === '5deea257f2fad353eed0e822') {
			const A = '5df00ad8f2fad353eed45e03';
			const B = '5df00ae8f2fad353eed45e14';
			const C = '5df00af4f2fad353eed45e25';
			const D = '5df00b04f2fad353eed45e36';
			// const E = '5df00b3cf2fad353eed45f0b'
			if (id === B || id === C || id === D) {
				this.handleAddTicket(e, A, add);
				return;
			}
		}
		// Event 3
		if (this.props.id === '5deea1d2f2fad353eed0e585') {
			const A = '5df00b60f2fad353eed460fc';
			const B = '5df00b6df2fad353eed4610d';
			const C = '5df00b79f2fad353eed4611e';
			const D = '5df00b86f2fad353eed46177';
			// const E = '5df00b95f2fad353eed4618c'
			if (id === B || id === C || id === D) {
				this.handleAddTicket(e, A, add);
				return;
			}
		}
		// Event 4
		if (this.props.id === '5deea00af2fad353eed0da34') {
			const A = '5df00bbcf2fad353eed4637d';
			const B = '5df00bcaf2fad353eed4638e';
			const C = '5df00bd8f2fad353eed4639f';
			const D = '5df00be5f2fad353eed463b0';
			// const E = '5df00c04f2fad353eed4640d'
			if (id === B || id === C || id === D) {
				this.handleAddTicket(e, A, add);
				return;
			}
		}
		// RISD HARDCODE PART 2 END =====================================================
	}

	// @todo Event Quota Reached
	public countTotalTicketPrice() {
		let totalPrice = 0;
		Object.keys(this.state.ticketOrder).forEach(tkey => {
			totalPrice +=
				this.state.ticketOrder[tkey].count * this.state.ticketOrder[tkey].price;
		});

		return totalPrice;
	}

	public countSubTotalPriceWithSfandTax() {
		if (this.countTotalTicketPrice() === 0) {
			return 0;
		}
		const feePerTicket = this.props.fees.perTicketFee * 100 || 0;
		const feePerOrder = this.props.fees.perOrderFee || 0;
		const taxPercentage: number = this.props.fees.taxPercentage ? this.props.fees.taxPercentage : 0

		let subTotalWithSf = 0;
		Object.keys(this.state.ticketOrder).forEach(tkey => {
			if (this.state.ticketOrder[tkey].price !== 0) {
				subTotalWithSf +=
					this.state.ticketOrder[tkey].count * (this.state.ticketOrder[tkey].price * (1 + (feePerOrder + taxPercentage) / 100) + feePerTicket);
			}
		});
		return subTotalWithSf;
	}

	public countTotalPrice() {
		let totalPrice = 0;
		const subTotalWithSf = this.countSubTotalPriceWithSfandTax();
		totalPrice = (subTotalWithSf + 30) / (1 - 0.029);
		totalPrice = parseInt(totalPrice.toFixed(0), 0);
		return subTotalWithSf === 0 ? 0 : totalPrice;
	}

	public countTax() {
		const tax = this.countTotalTicketPrice() * (this.props.fees.taxPercentage ? Number(this.props.fees.taxPercentage) : 0) / 100
		return tax;
	}

	public countTotalTickets() {
		let totalTickets = 0;
		Object.keys(this.state.ticketOrder).forEach(tkey => {
			totalTickets += this.state.ticketOrder[tkey].count;
		});

		return totalTickets;
	}

	public handleFormInputChange(e: any) {
		const { name, value } = e.target;

		this.setState({
			formData: {
				...this.state.formData,
				[name]: value,
			},
			error: false
		});
		this.props.cleanError();
	}

	public handleEmailInputChange(e: any) {
		const { name, value } = e.target;

		this.setState({
			formData: {
				...this.state.formData,
				[name]: value.trim().toLowerCase(),
			},
			error: false
		});
		this.props.cleanError();
	}

	public handleFirstNameChange(e: any) {
		this.setState({
			firstName: e.target.value,
			formData: {
				...this.state.formData,
				fullName: e.target.value + ' ' + this.state.lastInitial + '.'
			}
		})
	}

	public handlePhoneNumberChange(e: any) {
		this.setState({
			formData: {
				...this.state.formData,
				phoneNumber: e.target.value
			}
		})
	}

	public handleLastInitialChange(e: any) {

		if (e.target.value.length > 1) {
			return
		} else {
			this.setState({
				lastInitial: e.target.value,
				formData: {
					...this.state.formData,
					fullName: this.state.firstName + ' ' + e.target.value + '.'
				}
			})
		}
	}

	public emailIsValid(email) {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
	}

	public handlePurchase(e: any) {
		e.preventDefault()
		if (this.state.formData.fullName === '' || /\d/.test(this.state.formData.fullName)) {
			this.setState({ error: true });
			return;
		}

		if (this.props.lastInitialOnly === true) {
			if (this.state.firstName === '' || this.state.lastInitial === '' || this.state.lastInitial.length !== 1) {
				this.setState({ error: true })
				return;
			}
		}

		// Only for RISD event
		// if (this.props.id === '5deea257f2fad353eed0e822' || this.props.id === '5e28bddffb65960ef12149a0') {
		// 	if (this.state.formData.phoneNumber === '') {
		// 		this.setState({ error: true });
		// 		return;
		// 	}
		// }

		if (this.state.formData.email === '') {
			this.setState({ error: true });
			return;
		}

		if (!this.emailIsValid(this.state.formData.email)) {
			this.setState({ error: true });
			return;
		}

		if (!this.emailIsValid(this.state.formData.emailConfirm)) {
			this.setState({ error: true });
			return;
		}

		if (this.state.formData.emailConfirm !== this.state.formData.email) {
			this.setState({ error: true });
			return;
		}

		this.setState({
			error: false
		});

		setInterval(() => {
			this.setState({ charging: false });
		}, 3000);
		const temp = this.state.formData;
		this.props.createCharge(temp, {
			// Overhere we need to do the private ticket code if is defined..
			code: this.props.ticketCode,
			promoterId: this.props.promoterId,
			isFree: this.countTotalTicketPrice() === 0,
			ticketComponents: Object.keys(
				this.state.ticketOrder,
			).map(id => {
				return {
					ticketBankId: id,
					count: this.state.ticketOrder[id].count,
					price: this.state.ticketOrder[id].price
				};
			}),
		}, this.props.fees.absorb ? true : false);
	}

	/**
	 * Used to resolve current count of picked ticket item
	 *
	 * @param titemId
	 */
	public getQty(titemId: string) {
		if (this.state.ticketOrder[titemId] !== undefined && this.state.ticketOrder[titemId] !== null) {
			if (this.state.ticketOrder[titemId].count) {
				return this.state.ticketOrder[titemId].count
			} else if (this.state.ticketOrder[titemId].qty) {
				return this.state.ticketOrder[titemId].qty
			}
		}
		return 0;
	}

	public renderTicketBreakDown() {
		const { fees } = this.props;
		if (fees.absorb) {
			return (
				<div className='ticket-total-price'>
					<span className='label'>Total price: </span>
					<span className='price'>
						{
							this.props.currency === 'INR' ? <span>&#8377;</span> : '$'
						}
						{(this.countTotalTicketPrice() / 100).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
					</span>
					<span className='clear' />
				</div>
			);
		}

		return (
			<React.Fragment>
				<div className='ticket-total-price'>
					<span className='label'><b>Subtotal: </b></span>
					<span className='price'>
						<b>
							{
								this.props.currency === 'INR' ? <span>&#8377;</span> : '$'
							}
							{(this.countTotalTicketPrice() / 100).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
						</b>
					</span>
					<span className='clear' />
				</div>
				<br />
				{
					this.countTax() !== 0 ?
						<div>
							<div className='ticket-total-price'>
								<span className='label'>Tax: </span>
								<span className='price'>
									{
										this.props.currency === 'INR' ? <span>&#8377;</span> : '$'
									}
									{(this.countTax() / 100).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
								</span>
								<span className='clear' />
							</div>
							<br />
						</div>
						: null
				}
				<div className='ticket-total-price'>
					<span className='label'>Service fees: </span>
					<span className='price'>
						{
							this.props.currency === 'INR' ? <span>&#8377;</span> : '$'
						}
						{((this.countSubTotalPriceWithSfandTax() - this.countTotalTicketPrice() - this.countTax()) / 100).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
					</span>
					<span className='clear' />
				</div>
				<br />
				<div className='ticket-total-price'>
					<span className='label'>Card processing fees: </span>
					<span className='price'>
						{
							this.props.currency === 'INR' ? <span>&#8377;</span> : '$'
						}
						{((this.countTotalPrice() - this.countSubTotalPriceWithSfandTax()) / 100).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
					</span>
					<span className='clear' />
				</div>
				<br />
				<div className='ticket-total-price'>
					<span className='label'><b>Total price: </b></span>
					<span className='price'>
						<b>
							{
								this.props.currency === 'INR' ? <span>&#8377;</span> : '$'
							}
							{(this.countTotalPrice() / 100).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
						</b>
					</span>
					<span className='clear' />
				</div>
			</React.Fragment>
		);
	}

	public render() {

		// console.log(this.props.createdBy)
		const { timeInfo } = this.state;
		let tickets = this.props.publicTickets;
		let isPrivate = false;

		if (this.props.privateTicket && this.props.privateTicket !== []) {
			isPrivate = true;
			tickets = this.props.privateTicket;
		}

		const publicTickets = tickets.sort((a, b) => {
			if (a.price < b.price) {
				return -1;
			}
			if (a.price > b.price) {
				return 1;
			}
			return 0;
		})

		return (
			<div
				style={{
					minHeight: '110vh',
					width: '100%',
					height: 'auto',
					color: '#4A4A4A'
				}}
			>

				{
					this.state.isBought ? <div style={{ width: '100%', textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
						<div style={{ width: '300px' }}>
							<p>
								<br /><br /><br />
							</p>
							<Error content="Ticket unavailable or already purchased." />
						</div>
					</div>
						: null
				}

				{this.state.isBought ? null :
					<div>
						{
							screen.width > 768 ?
								<Row>
									<Col>
										<Card >
											<div style={{ maxHeight: '250px', overflowY: 'hidden' }}>
												<CardImg top={true} width="100%"
													src={
														this.props.styling.promoImg
															? this.props.styling.promoImg
															: 'https://platform.isotopeticketing.com/landing.png'
													}
													alt="Event Image"
													style={{ borderTopLeftRadius: '15px', borderTopRightRadius: '15px' }}
												/>
											</div>
											<div>
												<div>
													<div>
														<p />
													</div>
													<div style={{ paddingRight: '10%', paddingLeft: '10%' }}>
														<div>
															<h2>{this.props.name || '-'}</h2>
															<p />
															<div style={{ fontSize: '14px' }}>
																<p>
																	<strong>
																		{this.state.user.name === null || this.state.user.name === ''
																			? ''
																			: 'Invited by ' + this.state.user.name + ' ' + this.state.user.lastname}
																	</strong>
																</p>

																<div>
																	<div style={{ float: 'left', width: '10%' }}>
																		<img src={Icons.place} alt="Where is event happening?" />
																	</div>
																	<div style={{ float: 'right', width: '90%' }}>
																		{this.props.location}
																	</div>
																</div>
																<p><br /></p>
																<div>
																	<div style={{ float: 'left', width: '10%' }}>
																		<img
																			src={Icons.materialCalendar}
																			alt="When is Event happening?"
																		/>
																	</div>
																	<div style={{ float: 'right', width: '90%' }}>
																		{
																			String(timeInfo.startMonth) + '.' + String(timeInfo.startDay) + '.' + String(timeInfo.startYear) + ' ' +
																			String(timeInfo.startHour) + ':' + (timeInfo.startMinutes / 10 < 1 ? String(timeInfo.startMinutes) + '0' : String(timeInfo.startMinutes))
																		}
																		{timeInfo.startAMPM ? 'PM' : 'AM'}
																		{" - "}
																		{
																			String(timeInfo.endMonth) + '.' + String(timeInfo.endDay) + '.' + String(timeInfo.endYear) + ' ' +
																			String(timeInfo.endHour) + ':' + (timeInfo.endMinutes / 10 < 1 ? String(timeInfo.endMinutes) + '0' : String(timeInfo.endMinutes))
																		}
																		{timeInfo.endAMPM ? 'PM' : 'AM'}
																	</div>
																</div>
																<p><br /></p>
																<div>
																	<div style={{ float: 'left', width: '10%', paddingLeft: '3px' }}>
																		<img src={Icons.userDark} alt="Who is event host?" />
																	</div>
																	<div style={{ float: 'right', width: '90%' }}>
																		{
																			this.props.id !== '5e8048057a3aa10ea99480bc'
																				&& this.props.id !== '5e894f3e7a3aa10ea99d2165'
																				&& this.props.id !== '5e89460d7a3aa10ea99d12a9'
																				&& this.props.id !== '5e88859c7a3aa10ea99c5055'
																				&& this.props.id !== '5e8aa7fb7a3aa10ea99ea32a'
																				&& this.props.id !== '5e8aaa017a3aa10ea99eb23e'
																				&& this.props.id !== '5e8b78b87a3aa10ea9a04ac4'
																				&& this.props.id !== '5eec25888f4c8f13e0db778c'
																				? <a href={'/host/' + this.props.createdBy + '/' + this.props.hostName.replace(/ /g, "-")} style={{ textDecoration: 'underline' }}>
																					{this.props.hostName}
																				</a> : this.props.hostName
																		}
																	</div>
																</div>
															</div>
															<p><br /></p>
															<div className='description'>
																<EventDescription maxLength={125}>
																	{this.props.description}
																</EventDescription>
																{
																	this.props.styling.descripImg ?
																		<div style={{ width: '100%', textAlign: 'center' }}>
																			<img src={this.props.styling.descripImg}
																				style={{ maxWidth: '50%', maxHeight: '3050px' }}
																			/>
																		</div>
																		: null
																}
															</div>
														</div>

														<p />
													</div>
												</div>
											</div>
										</Card>
										<p><br /></p>
										<div>
											<Card style={{ paddingRight: '5%', paddingLeft: '5%', paddingTop: '20px' }} key={publicTickets.toString()}>
												<p />
												{this.props.ticketCode ? (
													<h4>Your tickets</h4>
												) : (
														<h4>Choose Tickets</h4>
													)}
												<p />
												{publicTickets.length > 0
													? publicTickets.map(titem => {
														if (this.getQty(titem.id) !== 0 || !this.props.ticketCode) {
															if (!this.props.ticketCode && titem.goOnSaleAfter && this.props.id !== '5eec25888f4c8f13e0db778c') {
																const precursor = publicTickets.find((item) => item.id === titem.goOnSaleAfter || (item._id && item._id === titem.goOnSaleAfter));
																if (precursor && precursor.bought !== precursor.quantity) {
																	return null
																}
															}
															if (titem.id === '5ef2343d02b3881017c6d18e') {
																if (this.props.promoterId !== '5d633fbe4105f5165db03b9a'
																	&& this.props.promoterId !== '5ef1a3fdf4795e6eac6540ef') {
																	return null;
																}
															}
															return (
																<TicketItem
																	name={titem.name}
																	key={'titem-' + titem.id}
																	id={titem.id}
																	price={titem.price}
																	fee={titem.fee || 0}
																	available={titem.available}
																	qty={this.getQty(titem.id)}
																	handleAdd={this.handleAddTicket}
																	handleSubstract={this.handleAddTicket}
																	isPrivate={isPrivate}
																	eventId={this.props.id}
																	currency={this.props.currency}
																	description={titem.description}
																/>
															);
														}
													})
													: 'No tickets found.'}
												<p />
											</Card>
											<p><br /></p>
										</div>
									</Col>
									<Col>
										{
											this.props.onSale !== false ?
												<div>
													<Card style={{ paddingRight: '10%', paddingLeft: '10%', paddingTop: '20px', paddingBottom: '10px' }}>
														<div>
															<p />
															<h4>
																{
																	this.props.id === '5dcfc36b02881a24a2e7c402' ? 'Guest Information' : 'Buyer Information'
																}
															</h4>
															<p />
															{
																this.props.lastInitialOnly !== true ?
																	<Text
																		label='Full Name'
																		name='fullName'
																		value={this.state.formData.fullName}
																		onChange={this.handleFormInputChange}
																	/> :
																	<div>
																		<Text
																			label='First Name'
																			name='fullName'
																			value={this.state.firstName}
																			onChange={this.handleFirstNameChange}
																		/>
																		<Text
																			label='Last Name Initial'
																			name='lastInitial'
																			value={this.state.lastInitial}
																			onChange={this.handleLastInitialChange}
																		/>
																	</div>

															}
															<Text
																label='E-mail'
																required={true}
																name='email'
																value={this.state.formData.email}
																onChange={this.handleEmailInputChange}
															/>
															<Text
																label='Confirm e-mail'
																infoMessage='Your ticket will be sent to this email immediately upon purchase.'
																required={true}
																name='emailConfirm'
																value={this.state.formData.emailConfirm}
																onChange={this.handleEmailInputChange}
															/>
															{
																this.props.id === '5e894f3e7a3aa10ea99d2165'
																	|| this.props.id === '5e8aaa017a3aa10ea99eb23e'
																	|| this.props.id === '5e89460d7a3aa10ea99d12a9'
																	|| this.props.id === '5e88859c7a3aa10ea99c5055'
																	?
																	<Select
																		label="Pickup Time Slot"
																		value={this.state.formData.phoneNumber}
																		name="pickup"
																		onChange={this.handlePhoneNumberChange}
																		infoMessage={
																			"Choose a pick up time."
																		}
																	>
																		<option value="10-12">10-12</option>
																		<option value="12-2">12-2</option>
																		<option value="2-4">2-4</option>
																	</Select>
																	: null
															}
															{
																this.props.id === '5e8048057a3aa10ea99480bc' ?
																	<div>
																		<Switch
																			checked={!this.state.switched}
																			onChange={this.changeDonation}
																			onColor="#4d5adf"
																			onHandleColor="#ffffff"
																			handleDiameter={25}
																			uncheckedIcon={false}
																			checkedIcon={true}
																			boxShadow="0 2px 1px -1px gray"
																			height={25}
																			width={50}
																			className="react-switch"
																			id="material-switch"
																		/> <br />
																		<Label>
																			Donate this purchase to medical workers.
																		</Label>
																	</div>
																	: null
															}
															{
																this.props.id === '5e8048057a3aa10ea99480bc' && this.state.switched ?
																	<Text
																		label='Mailing Address'
																		infoMessage='Enter your full address.'
																		required={true}
																		name='phoneNumber'
																		value={this.state.formData.phoneNumber}
																		onChange={this.handlePhoneNumberChange}
																	/> : null
															}
															{
																(this.props.id === '5e28bddffb65960ef12149a0' &&
																	((this.state.ticketOrder['5e41e8f149fc4b22a837b66a'] && this.state.ticketOrder['5e41e8f149fc4b22a837b66a'].count !== 0) ||
																		(this.state.ticketOrder['5e41ea1449fc4b22a837c40c'] && this.state.ticketOrder['5e41ea1449fc4b22a837c40c'].count !== 0))
																) ?
																	<div>
																		<a
																			style={{ textDecoration: 'underline' }}
																			target="_blank"
																			href='https://drive.google.com/file/d/1mDl5O6sMctVsdQiZoLCRcxOl8m1zQW-J/view'>
																			View Color Choices
																	</a>
																		<br />
																		<a
																			style={{ textDecoration: 'underline' }}
																			target="_blank"
																			href='https://drive.google.com/file/d/1dOJg5YDYBvL-4bwpIjqEy1p5OoZsk4f1/view'>
																			View Festival Fan
																	</a>
																		<Text
																			label='Color choice'
																			infoMessage='Enter color choice.'
																			required={true}
																			name='phoneNumber'
																			value={this.state.formData.phoneNumber}
																			onChange={this.handlePhoneNumberChange}
																		/>
																	</div>
																	: null
															}
															{
																this.props.id === '5deea2d7f2fad353eed0eaab' ||
																	this.props.id === '5deea257f2fad353eed0e822' ||
																	this.props.id === '5deea1d2f2fad353eed0e585' ||
																	this.props.id === '5deea00af2fad353eed0da34' ?
																	<div style={{ paddingLeft: '25px' }}>
																		<Input
																			type="checkbox"
																			checked={this.state.agreedRISD}
																			onChange={e => {
																				this.setState({
																					agreedRISD: !this.state.agreedRISD
																				})
																			}}
																			style={{ height: 'auto' }}
																		/>
																		<span style={{ paddingLeft: '10px', paddingTop: '5px' }}>
																			I agree to the &nbsp;
																			<span style={{ textDecoration: 'underline', cursor: 'pointer' }}>
																				<a href={'../../../waiver.pdf'} target="_blank" style={{ textDecoration: 'underline' }}>RISD WAIVER</a><br />
																			</span>
																		</span>
																	</div> : null
															}
															<div style={{ paddingLeft: '25px' }}>
																<Input
																	type="checkbox"
																	checked={this.state.agreed}
																	onChange={e => {
																		this.setState({
																			agreed: !this.state.agreed
																		})
																	}}
																	style={{ height: 'auto' }}
																/>
																<span style={{ paddingLeft: '10px', paddingTop: '5px' }}>
																	I agree to the &nbsp;
																<span style={{ cursor: 'pointer' }}>
																		<a target="_blank" href="../../../termsandconditions.pdf">terms and conditions</a>
																	</span>
																	<br />
																</span>
															</div>
															{this.state.error === true ? <Error content={"Please fill out information correctly"} /> : null}
															{this.props.purchaseError === true ?
																<Error content={
																	this.props.errorMsg === "PAYMENT_ERROR" ?
																		"Invalid card information provided, try again" :
																		this.props.errorMsg === "NQUOTA" ?
																			"Requested tickets are unavailable, please refresh" :
																			this.props.errorMsg === "BOUGHT" ?
																				"Ticket is not available, please refresh" :
																				this.props.errorMsg === "RES_EMAIL" ?
																					"Email ID not authorized to purchase tickets" :
																					this.props.errorMsg === "RISD" ?
																						"Email ID not authorized to buy more tickets" :
																						this.props.errorMsg === "RISD2" ?
																							"You are authorized to only buy one more ticket" :
																							"Ticket record does not match"
																} />
																: null}
															{this.countTotalTicketPrice() > 0 ? (
																<div style={{
																	width: '100%',
																	overflow: 'scroll'
																}}>
																	<Card style={{ minWidth: '240px', boxShadow: 'none', font: 'Rubik' }}>
																		<Label><br />Payment Information</Label>
																		<CreditCardForm />
																	</Card>
																</div>
															) : (
																	<span />
																)}
														</div>
														<p />
													</Card>
													<p><br /></p>
													<Card style={{ paddingRight: '10%', paddingLeft: '10%', paddingTop: '20px' }}>
														<div className="gray">
															<p />
															<h4>
																{
																	this.props.id === '5dcfc36b02881a24a2e7c402' ? null : 'Price Breakdown'
																}
															</h4>
															<div className='ticket-total-price'>
																{
																	this.props.id === '5dcfc36b02881a24a2e7c402' ? null :
																		<p style={{ fontSize: "12px", color: "#4A4A4A", textAlign: "justify" }}>
																			<br />All sales are final. In the case of an event cancellation, refunds of the base ticket price
																			will be issued to each customer’s card used to purchase. All service fees and payment processing
																			fees are non-refundable. By purchasing a ticket, you agree to this purchase policy. This transaction
																			will post as “ISOTOPE TICKETING” on your bank statement. Tickets will be delivered to your provided
																			email address. The venue and/or event host reserves their right to refuse entry.
																			<br /><br />
																		</p>
																}
															</div>
															<p />
															{

																this.props.id === '5dcfc36b02881a24a2e7c402' ? null :
																	this.renderTicketBreakDown()
															}
															<div className='ticket-pay'>
																<p />
																<div style={{
																	textAlign: 'center'
																}}>
																	<Button
																		className='new-button-blue-gradient'
																		disabled={
																			this.countTotalTickets() === 0 || this.props.charging || !this.state.agreed || !this.state.agreedRISD
																		}
																		onClick={e => {
																			this.handlePurchase(e)
																		}}
																		style={{ border: 'none', color: this.countTotalTickets() === 0 || this.props.charging || !this.state.agreed || !this.state.agreedRISD ? '#f8f8f8' : '#f8f8f8' }}
																	>
																		{this.countTotalTickets() > 0
																			? this.countTotalTicketPrice() === 0 ? 'Get Tickets' : 'Buy Tickets'
																			: 'Choose Tickets'}
																	</Button>
																</div>
																<div className='powered-by-stripe'>
																	<img
																		src='/static/icons/powered_by_stripe.svg'
																		alt='Secured & Powered by STRIPE'
																	/>
																</div>
															</div>
														</div>
													</Card>
													<p><br /></p>
												</div> :
												<div>
													<Card>
														<p><br /></p>
														<h4 className="sexyBlack" style={{ textAlign: 'center', paddingLeft: '10%', paddingRight: '10%' }}>
															{
																this.props.id === '5d975f25a6404e72b39b6ffe' ?
																	'Event not live. Class of 2020 can purchase tickets starting 10am 10/22. All RISD students can purchase tickets starting 10/23-10/25 until sold out.'
																	: this.props.isActive ? 'Event not live, check again later.' : 'Event has ended.'
															}
														</h4>
														<p><br /></p>
													</Card>
													<p><br /></p>
												</div>
										}
									</Col>
								</Row>

								:

								<Row>
									<Col>
										<Card >
											<div style={{ maxHeight: '250px', overflowY: 'hidden' }}>
												<CardImg top={true} width="100%"
													src={
														this.props.styling.promoImg
															? this.props.styling.promoImg
															: 'https://platform.isotopeticketing.com/landing.png'
													}
													alt="Event Image"
													style={{ borderTopLeftRadius: '15px', borderTopRightRadius: '15px' }}
												/>
											</div>
											<div>
												<div>
													<div>
														<p />
													</div>
													<div style={{ paddingRight: '10%', paddingLeft: '10%' }}>
														<div>
															<h2>{this.props.name || '-'}</h2>
															<p />
															<div style={{ fontSize: '14px' }}>
																<p>
																	<strong>
																		{this.state.user.name === null || this.state.user.name === ''
																			? ''
																			: 'Invited by ' + this.state.user.name + ' ' + this.state.user.lastname}
																	</strong>
																</p>

																<div>
																	<div style={{ float: 'left', width: '10%' }}><img src={Icons.place} alt="Where is event happening?" /></div>
																	<div style={{ float: 'right', width: '90%' }}>
																		{this.props.location}
																	</div>
																</div>
																<p><br /></p>
																<div>
																	<div style={{ float: 'left', width: '10%' }}>
																		<img
																			src={Icons.materialCalendar}
																			alt="When is Event happening?"
																		/>
																	</div>
																	<div style={{ float: 'right', width: '90%' }}>
																		{
																			String(timeInfo.startMonth) + '.' + String(timeInfo.startDay) + '.' + String(timeInfo.startYear) + ' ' +
																			String(timeInfo.startHour) + ':' + (timeInfo.startMinutes / 10 < 1 ? String(timeInfo.startMinutes) + '0' : String(timeInfo.startMinutes))
																		}
																		{timeInfo.startAMPM ? 'PM' : 'AM'}
																		{" - "}
																		{
																			String(timeInfo.endMonth) + '.' + String(timeInfo.endDay) + '.' + String(timeInfo.endYear) + ' ' +
																			String(timeInfo.endHour) + ':' + (timeInfo.endMinutes / 10 < 1 ? String(timeInfo.endMinutes) + '0' : String(timeInfo.endMinutes))
																		}
																		{timeInfo.endAMPM ? 'PM' : 'AM'}
																	</div>
																</div>
																<p><br /></p>
																<div>
																	<div style={{ float: 'left', width: '10%', paddingLeft: '3px' }}>
																		<img src={Icons.userDark} alt="Who is event host?" />
																	</div>
																	<div style={{ float: 'right', width: '90%' }}>
																		{
																			this.props.id !== '5e8048057a3aa10ea99480bc'
																				&& this.props.id !== '5eec25888f4c8f13e0db778c'
																				? <a href={'/host/' + this.props.createdBy + '/' + this.props.hostName.replace(/ /g, "-")} style={{ textDecoration: 'underline' }}>
																					{this.props.hostName}
																				</a> : this.props.hostName
																		}
																	</div>
																</div>
															</div>
															<p><br /></p>
															<div className='description'>
																<EventDescription maxLength={125}>
																	{this.props.description}
																</EventDescription>
																{
																	this.props.styling.descripImg ?
																		<div style={{ width: '100%', textAlign: 'center' }}>
																			<img src={this.props.styling.descripImg}
																				style={{ maxWidth: '50%', maxHeight: '3050px' }}
																			/>
																		</div>
																		: null
																}
															</div>
														</div>

														<p />
													</div>
												</div>
											</div>
										</Card>
										<p><br /></p>
										<div>
											<Card style={{ paddingRight: '5%', paddingLeft: '5%', paddingTop: '20px' }} key={publicTickets.toString()}>
												<p />
												{this.props.ticketCode ? (
													<h4>Your tickets</h4>
												) : (
														<h4>Choose Tickets</h4>
													)}
												<p />
												{publicTickets.length > 0
													? publicTickets.map(titem => {
														if (this.getQty(titem.id) !== 0 || !this.props.ticketCode) {
															if (!this.props.ticketCode && titem.goOnSaleAfter && this.props.id !== '5eec25888f4c8f13e0db778c') {
																const precursor = publicTickets.find((item) => item.id === titem.goOnSaleAfter || (item._id && item._id === titem.goOnSaleAfter));
																if (precursor && precursor.bought !== precursor.quantity) {
																	return null
																}
															}
															if (titem.id === '5ef2343d02b3881017c6d18e') {
																if (this.props.promoterId !== '5d633fbe4105f5165db03b9a'
																	&& this.props.promoterId !== '5ef1a3fdf4795e6eac6540ef') {
																	return null;
																}
															}
															return (
																<TicketItem
																	name={titem.name}
																	key={'titem-' + titem.id}
																	id={titem.id}
																	price={titem.price}
																	fee={titem.fee || 0}
																	available={titem.available}
																	qty={this.getQty(titem.id)}
																	handleAdd={this.handleAddTicket}
																	handleSubstract={this.handleAddTicket}
																	isPrivate={isPrivate}
																	eventId={this.props.id}
																	currency={this.props.currency}
																	description={titem.description}
																/>
															);
														}
													})
													: 'No tickets found.'}
												<p />
											</Card>
											<p><br /></p>
										</div>
										{
											this.props.onSale !== false ?
												<div>
													<Card style={{ paddingRight: '10%', paddingLeft: '10%', paddingTop: '20px', paddingBottom: '10px' }}>
														<div>
															<p />
															<h4>
																{
																	this.props.id === '5dcfc36b02881a24a2e7c402' ? 'Guest Information' : 'Buyer Information'
																}
															</h4>
															<p />
															{
																this.props.lastInitialOnly !== true ?
																	<Text
																		label='Full Name'
																		name='fullName'
																		value={this.state.formData.fullName}
																		onChange={this.handleFormInputChange}
																	/> :
																	<div>
																		<Text
																			label='First Name'
																			name='fullName'
																			value={this.state.firstName}
																			onChange={this.handleFirstNameChange}
																		/>
																		<Text
																			label='Last Name Initial'
																			name='lastInitial'
																			value={this.state.lastInitial}
																			onChange={this.handleLastInitialChange}
																		/>
																	</div>

															}
															<Text
																label='E-mail'
																required={true}
																name='email'
																value={this.state.formData.email}
																onChange={this.handleEmailInputChange}
															/>
															<Text
																label='Confirm e-mail'
																infoMessage='Your ticket will be sent to this email immediately upon purchase.'
																required={true}
																name='emailConfirm'
																value={this.state.formData.emailConfirm}
																onChange={this.handleEmailInputChange}
															/>
															{
																this.props.id === '5e894f3e7a3aa10ea99d2165'
																	|| this.props.id === '5e8aaa017a3aa10ea99eb23e'
																	|| this.props.id === '5e89460d7a3aa10ea99d12a9'
																	|| this.props.id === '5e88859c7a3aa10ea99c5055'
																	?
																	<Select
																		label="Pickup Time Slot"
																		value={this.state.formData.phoneNumber}
																		name="pickup"
																		onChange={this.handlePhoneNumberChange}
																		infoMessage={
																			"Choose a pick up time."
																		}
																	>
																		<option value="10-12">10-12</option>
																		<option value="12-2">12-2</option>
																		<option value="2-4">2-4</option>
																	</Select>
																	: null
															}
															{
																this.props.id === '5e8048057a3aa10ea99480bc' ?
																	<div>
																		<Switch
																			checked={!this.state.switched}
																			onChange={this.changeDonation}
																			onColor="#4d5adf"
																			onHandleColor="#ffffff"
																			handleDiameter={25}
																			uncheckedIcon={false}
																			checkedIcon={true}
																			boxShadow="0 2px 1px -1px gray"
																			height={25}
																			width={50}
																			className="react-switch"
																			id="material-switch"
																		/> <br />
																		<Label>
																			Donate this purchase to medical workers.
																		</Label>
																	</div>
																	: null
															}
															{
																this.props.id === '5e8048057a3aa10ea99480bc' && this.state.switched ?
																	<Text
																		label='Mailing Address'
																		infoMessage='Enter your full address.'
																		required={true}
																		name='phoneNumber'
																		value={this.state.formData.phoneNumber}
																		onChange={this.handlePhoneNumberChange}
																	/> : null
															}
															{
																(this.props.id === '5e28bddffb65960ef12149a0' &&
																	((this.state.ticketOrder['5e41e8f149fc4b22a837b66a'] && this.state.ticketOrder['5e41e8f149fc4b22a837b66a'].count !== 0) ||
																		(this.state.ticketOrder['5e41ea1449fc4b22a837c40c'] && this.state.ticketOrder['5e41ea1449fc4b22a837c40c'].count !== 0))
																) ?
																	<div>
																		<a
																			style={{ textDecoration: 'underline' }}
																			target="_blank"
																			href='https://drive.google.com/file/d/1mDl5O6sMctVsdQiZoLCRcxOl8m1zQW-J/view'>
																			View Color Choices
																			</a>
																		<br />
																		<a
																			style={{ textDecoration: 'underline' }}
																			target="_blank"
																			href='https://drive.google.com/file/d/1dOJg5YDYBvL-4bwpIjqEy1p5OoZsk4f1/view'>
																			View Festival Fan
																			</a>
																		<Text
																			label='Color choice'
																			infoMessage='Enter color choice.'
																			required={true}
																			name='phoneNumber'
																			value={this.state.formData.phoneNumber}
																			onChange={this.handlePhoneNumberChange}
																		/>
																	</div> : null
															}
															{
																this.props.id === '5deea2d7f2fad353eed0eaab' ||
																	this.props.id === '5deea257f2fad353eed0e822' ||
																	this.props.id === '5deea1d2f2fad353eed0e585' ||
																	this.props.id === '5deea00af2fad353eed0da34'
																	?
																	<div style={{ paddingLeft: '25px' }}>
																		<Input
																			type="checkbox"
																			checked={this.state.agreedRISD}
																			onChange={e => {
																				this.setState({
																					agreedRISD: !this.state.agreedRISD
																				})
																			}}
																			style={{ height: 'auto' }}
																		/>
																		<span style={{ paddingLeft: '10px', paddingTop: '5px' }}>
																			I agree to the &nbsp;
																			<span style={{ textDecoration: 'underline', cursor: 'pointer' }}>
																				<a href={'../../../waiver.pdf'} target="_blank" style={{ textDecoration: 'underline' }}>RISD WAIVER</a><br />
																			</span>
																		</span>
																	</div> : null
															}
															<div style={{ paddingLeft: '25px' }}>
																<Input
																	type="checkbox"
																	checked={this.state.agreed}
																	onChange={e => {
																		this.setState({
																			agreed: !this.state.agreed
																		})
																	}}
																	style={{ height: 'auto' }}
																/>
																<span style={{ paddingLeft: '10px', paddingTop: '5px' }}>
																	I agree to the &nbsp;
																	<span style={{ cursor: 'pointer' }}>
																		<a target="_blank" href="../../../termsandconditions.pdf">terms and conditions</a>
																	</span>
																	<br /></span>
															</div>
															{/* {this.state.emailError === true ? <Error content={"The email addresses don't match, please check again"}/> : null} */}
															{this.state.error === true ? <Error content={"Please fill out information correctly"} /> : null}
															{this.props.purchaseError === true ?
																<Error content={
																	this.props.errorMsg === "PAYMENT_ERROR" ?
																		"Invalid card information provided, try again" :
																		this.props.errorMsg === "NQUOTA" ?
																			"Requested tickets are unavailable, please refresh" :
																			this.props.errorMsg === "BOUGHT" ?
																				"Ticket is not available, please refresh" :
																				this.props.errorMsg === "RES_EMAIL" ?
																					"Email ID not authorized to purchase tickets" :
																					this.props.errorMsg === "RISD" ?
																						"Email ID not authorized to buy more tickets" :
																						this.props.errorMsg === "RISD2" ?
																							"You are authorized to only buy one more ticket" :
																							"Ticket record does not match"
																} />
																: null}
															{this.countTotalTicketPrice() > 0 ? (
																<div style={{
																	width: '100%',
																	overflow: 'scroll'
																}}>
																	<Card style={{ minWidth: '240px', boxShadow: 'none', font: 'Rubik' }}>
																		<Label><br />Payment Information</Label>
																		<CreditCardForm />
																	</Card>
																</div>
															) : (
																	<span />
																)}
														</div>
														<p />
													</Card>
													<p><br /></p>
													<Card style={{ paddingRight: '10%', paddingLeft: '10%', paddingTop: '20px' }}>
														<div className="gray">
															<p />
															<h4>
																{
																	this.props.id === '5dcfc36b02881a24a2e7c402' ? null : 'Price Breakdown'
																}
															</h4>
															<div className='ticket-total-price'>
																{
																	this.props.id === '5dcfc36b02881a24a2e7c402' ? null :
																		<p style={{ fontSize: "12px", color: "#4A4A4A", textAlign: "justify" }}>
																			<br />All sales are final. In the case of an event cancellation, refunds of the base ticket price
																			will be issued to each customer’s card used to purchase. All service fees and payment processing
																			fees are non-refundable. By purchasing a ticket, you agree to this purchase policy. This transaction
																			will post as “ISOTOPE TICKETING” on your bank statement. Tickets will be delivered to your provided
																			email address. The venue and/or event host reserves their right to refuse entry.
																			<br /><br />
																		</p>
																}
															</div>
															<p />
															{
																this.props.id === '5dcfc36b02881a24a2e7c402' ? null : this.renderTicketBreakDown()
															}
															<div className='ticket-pay'>
																<p />
																<div className="align-mobile-center">
																	<Button
																		className='new-button-blue-gradient'
																		style={{ border: 'none', color: this.countTotalTickets() === 0 || this.props.charging || !this.state.agreed || !this.state.agreedRISD ? '#f8f8f8' : '#f8f8f8' }}
																		disabled={
																			this.countTotalTickets() === 0 || this.props.charging || !this.state.agreed || !this.state.agreedRISD
																		}
																		onClick={e => {
																			this.handlePurchase(e)
																		}}
																	>
																		{this.countTotalTickets() > 0
																			? this.countTotalTicketPrice() === 0 ? 'Get Tickets' : 'Buy Tickets'
																			: 'Choose Tickets'}
																	</Button>
																</div>
																<div className='powered-by-stripe'>
																	<img
																		src='/static/icons/powered_by_stripe.svg'
																		alt='Secured & Powered by STRIPE'
																	/>
																</div>
															</div>
														</div>
													</Card>
													<p><br /></p>
												</div> :
												<div>
													<Card>
														<p><br /></p>
														<h4 className="sexyBlack" style={{ textAlign: 'center', paddingLeft: '10%', paddingRight: '10%' }}>
															{
																this.props.id === '5d975f25a6404e72b39b6ffe' ?
																	'Event not live. Class of 2020 can purchase tickets starting 10am 10/22. All RISD students can purchase tickets starting 10/23-10/25 until sold out.'
																	: this.props.isActive ? 'Event not live, check again later.' : 'Event has ended.'
															}
														</h4>
														<p><br /></p>
													</Card>
													<p><br /></p>
												</div>
										}
									</Col>
								</Row>

						}
					</div>
				}
				{
					this.props.id !== '5e8048057a3aa10ea99480bc'
						&& this.props.id !== '5e894f3e7a3aa10ea99d2165'
						&& this.props.id !== '5e89460d7a3aa10ea99d12a9'
						&& this.props.id !== '5e88859c7a3aa10ea99c5055'
						&& this.props.id !== '5e8aa7fb7a3aa10ea99ea32a'
						&& this.props.id !== '5e8aaa017a3aa10ea99eb23e'
						&& this.props.id !== '5e8b78b87a3aa10ea9a04ac4'
						&& this.props.id !== '5eec25888f4c8f13e0db778c'
						?
						<Row>
							<Col>
								<div style={{ width: '100%' }}>
									<MoreEventsByCheckoutPage
										userId={this.props.createdBy}
										hostname={this.props.hostName}
									/>
								</div>
							</Col>
						</Row> : null
				}
			</div>

		);
	}
}

export default withCookies(CheckOut);


// WEBPACK FOOTER //
// ./src/pages/event/public/components/CheckOut.tsx